import type { AntibodyResponse } from '../types';

/**
 * Selection Utilities
 *
 * Helper functions for selecting sequences based on various criteria
 */

/**
 * Select top X sequences by APS score per clonotype
 *
 * @param clonotypes - Array of clonotypes
 * @param topCount - Number of top sequences to select per clonotype
 * @returns Array of sequence keys in format "clonotypeId-sequenceId"
 */
export const selectTopAPSSequences = (clonotypes: AntibodyResponse[], topCount: number): string[] => {
  const selectedKeys: string[] = [];

  // For each clonotype, get the top X sequences by APS score
  clonotypes.forEach((clonotype) => {
    const sortedSequences = [...clonotype.sequences]
      .sort((a, b) => {
        const apsA = a.metadata.aps ?? 0;
        const apsB = b.metadata.aps ?? 0;
        return apsB - apsA; // Descending order (highest first)
      })
      .slice(0, topCount); // Take only the top X

    // Add sequence keys to selection
    sortedSequences.forEach((seq) => {
      selectedKeys.push(`${clonotype.id}-${seq.metadata.sequenceId}`);
    });
  });

  return selectedKeys;
};
